import { Branch } from "./branches/impl/model/Branch";
import { Country } from "./countrydetection/impl/model/Country";
import { Context } from "./core/impl/Context";
import { CountriesManager } from "./countrydetection/impl/manager/CountriesManager";
import { BranchesManager } from "./branches/impl/manager/BranchesManager";
import { NetworkInstance } from "./networkinstances/impl/model/NetworkInstance";
import { NetworkInstancesManager } from "./networkinstances/impl/manager/NetworkInstancesManager";
import { NetworkSettings } from "./config/NetworkSettings";

export class WorldAssignmentFacade {
    // move all GGSCountryController related stuff here
    public get defaultCountry(): Country {
        return (<CountriesManager>Context.instance.get(CountriesManager)).defaultCountry;
    }


    public get currentCountry(): Country {
        return (<CountriesManager>Context.instance.get(CountriesManager)).currentCountry;
    }


    public get detectionFactor(): number {
        return (<CountriesManager>Context.instance.get(CountriesManager)).detectionFactor;
    }


    public get activeCountries(): ReadonlyArray<Country> {
        return (<CountriesManager>Context.instance.get(CountriesManager)).activeCountries;
    }


    public get allCountries(): ReadonlyArray<Country> {
        return (<CountriesManager>Context.instance.get(CountriesManager)).allCountries;
    }


    public get notSupportedCountries(): ReadonlyArray<Country> {
        return (<CountriesManager>Context.instance.get(CountriesManager)).notSupportedCountries;
    }


    public get branches(): ReadonlyArray<Branch> {
        return (<BranchesManager>Context.instance.get(BranchesManager)).branches;
    }


    public get currentBranch(): Branch {
        return (<BranchesManager>Context.instance.get(BranchesManager)).currentBranch;
    }


    public get networkInstances(): ReadonlyArray<NetworkInstance> {
        return (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).networkInstances;
    }

    public get networkSettings(): Readonly<NetworkSettings> {
        return Context.instance.get(NetworkSettings);
    }

    public get selectedNetworkInstance(): NetworkInstance {
        return (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).selectedNetworkInstance;
    }

    public getBranchByZoneId(zoneId: string): Branch {
        return (<BranchesManager>Context.instance.get(BranchesManager)).getBranchByZoneId(zoneId);
    }

    public getInstanceByZoneId(zoneId: number): NetworkInstance {
        return (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).getInstanceByZoneId(zoneId);
    }

    public getInstanceById(id: number): NetworkInstance {
        return (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).getInstanceById(id);
    }

    public getInstancesByCountryCode(countryCode: string): ReadonlyArray<NetworkInstance> {
        return (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).getInstancesByCountryCode(countryCode);
    }

}
